import {WS} from "../ws/ws";

export abstract class AudioHandler {
    private screenStream: MediaStream | null = null;

    abstract startRecording(stream: MediaStream): Promise<void>

    protected constraints: MediaStreamConstraints = {
        audio: true
    };

    public constructor(
        public ws: WS,
    ) {
    }

    async startScreenRecording() {
        this.screenStream = await navigator.mediaDevices.getDisplayMedia(this.constraints);

        const audioContext = new AudioContext();
        const destination = audioContext.createMediaStreamDestination();
        audioContext.createMediaStreamSource(this.screenStream).connect(destination);

        await this.startRecording(destination.stream);
    }

    async startMicRecording() {
        const permission = await navigator.permissions.query({name: 'microphone' as PermissionName});
        if (permission.state === 'denied') throw new Error('MIC_BLOCKED');

        await this.startRecording(await navigator.mediaDevices.getUserMedia(this.constraints));
    }

    protected stopStream(stream: MediaStream | null) {
        stream?.getTracks().forEach((track) => track.stop());
        return null
    }

    async stop() {
        this.screenStream = this.stopStream(this.screenStream);
        await this.ws.close()
        console.info("[AudioHandler] stopped.");
    }
}
